import { defineComponent as _defineComponent } from 'vue'
import BuilderEstimatorStepTitle from "@/components/builder/estimator-tool/BuilderEstimatorStepTitle.vue";
  import BuilderEstimatorSummaryItem from "./BuilderEstimatorSummaryItem.vue";
  import BuilderEstimatorSummaryDesignForm from "./BuilderEstimatorSummaryDesignForm.vue";
  import BuilderEstimatorSummarySuccessMessage from "./BuilderEstimatorSummarySuccessMessage.vue";
  import type { IBuilderEstimatorFormData } from "@/types/BuilderEstimatorFormData";
  import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  import { computed, ref, watch } from "vue";
  import { SummaryUserSelectionFormData } from "@/types/BuilderEstimatorMapper";
  import { FormSummaryType } from "@/enums/FormSummaryType";
  import { getAllSummaryItemsFromForm } from "@/helpers/builder/getAllSummaryItemsFromForm";
  import BuilderEstimatorHouseCustomizeSlider from "./builder-estimator-selection-house/house-carousel/BuilderEstimatorHouseCustomizeSlider.vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSummaryMobile',
  props: {
    builderLogo: {},
    formData: {},
    totalPrice: {},
    showSuccessMessage: { type: Boolean }
  },
  emits: ["select-prev", "on-submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const userSelectionsToSliderImages = computed(() => {
    if (!props.formData) return [];

    return [
      ...(props.formData[BuilderEstimatorSteps.SELECT_DESIGN]?.houseDesign
        ?.mainImages ?? []),
      props.formData[BuilderEstimatorSteps.SELECT_FACADE].facade?.url,
      props.formData[BuilderEstimatorSteps.SELECT_EXTERNAL_COLOURS]
        .externalColorScheme?.imagesUrls,
      props.formData[BuilderEstimatorSteps.SELECT_INTERNAL_COLOURS]
        .internalColorScheme?.imagesUrls,
    ]
      .flat()
      .filter(Boolean);
  });
  const props = __props;

  const emit = __emit;

  const isLoading = ref<boolean>(false);
  const isFormOpen = ref<boolean>(false);
  const submitSuccessful = ref<boolean>(true);
  const formTypeSelected = ref<FormSummaryType | null>(null);
  const onSelectPrev = () => {
    if (isFormOpen.value) {
      isFormOpen.value = false;
    } else {
      emit("select-prev");
      window.scrollTo(0, 0);
    }
  };

  const onSubmit = () => {
    emit("on-submit");
  };

  const onGetFreeDesign = () => {
    formTypeSelected.value = FormSummaryType.FREE_DESIGN;
    isFormOpen.value = true;
    window.scrollTo(0, 0);
  };

  const onBookConsultation = () => {
    formTypeSelected.value = FormSummaryType.CONSULTATION;
    isFormOpen.value = true;
    window.scrollTo(0, 0);
  };

  const resetForm = () => {
    isFormOpen.value = false;
    submitSuccessful.value = false;
  };
  const canShowSuccessMessage = computed(() => {
    if (props.showSuccessMessage && submitSuccessful.value) return true;

    return false;
  });

  const onFormSubmit = (data: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  }) => {
    emit("on-submit", {
      ...data,
      totalPrice: props.totalPrice,
      userSelectedOptions: props.formData,
      formSummaryType: formTypeSelected.value,
    });
    submitSuccessful.value = true;
  };

  const { allSummaryItems } = getAllSummaryItemsFromForm(props.formData);

const __returned__ = { userSelectionsToSliderImages, props, emit, isLoading, isFormOpen, submitSuccessful, formTypeSelected, onSelectPrev, onSubmit, onGetFreeDesign, onBookConsultation, resetForm, canShowSuccessMessage, onFormSubmit, allSummaryItems, BuilderEstimatorStepTitle, BuilderEstimatorSummaryItem, BuilderEstimatorSummaryDesignForm, BuilderEstimatorSummarySuccessMessage, get BuilderEstimatorSteps() { return BuilderEstimatorSteps }, computed, ref, watch, get SummaryUserSelectionFormData() { return SummaryUserSelectionFormData }, get FormSummaryType() { return FormSummaryType }, get getAllSummaryItemsFromForm() { return getAllSummaryItemsFromForm }, BuilderEstimatorHouseCustomizeSlider }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})